import {inject, Injectable} from "@angular/core";
import {AdminSettingApiService, SettingApiService, SettingState, TableSort, UserSettingApiService} from "../../generated-sources/api/user-setting";
import {Observable} from "rxjs";

@Injectable({
    providedIn: "root"
})
export class UserSettingService {
    private readonly userSettingApi = inject(UserSettingApiService);
    private readonly adminSettingApi = inject(AdminSettingApiService);
    private readonly settingApi = inject(SettingApiService);

    getMergedSettings(): Observable<Record<string, any>> {
        return this.userSettingApi.getMergedSettings();
    }

    getSettingDefinitions(): Observable<SettingState[]> {
        return this.settingApi.getSettingDefinitions();
    }

    saveAdminLock(key: string, overridable: boolean): Observable<void> {
        return this.adminSettingApi.saveAdminLock(key, {value: overridable});
    }

    saveUserSetting(key: string, value: any): Observable<void> {
        return this.userSettingApi.saveUserSetting(key, {value});
    }

    deleteUserSetting(key: string): Observable<void> {
        return this.userSettingApi.deleteUserSetting(key);
    }

    getAdminSettings(): Observable<Record<string, any>> {
        return this.adminSettingApi.getAdminSettings();
    }

    saveAdminSetting(key: string, value: any): Observable<void> {
        return this.adminSettingApi.saveAdminSetting(key, {value});
    }

    saveTableSettings(tableKey: string, columns: string[], pageSize: number, sort: TableSort): Observable<Record<string, any>> {
        return this.userSettingApi.saveTableSettings(tableKey, {columns, pageSize, sort});
    }

    deleteTableSettings(tableKey: string): Observable<Record<string, any>> {
        return this.userSettingApi.deleteTableSettings(tableKey);
    }

    saveAdminTableSettings(tableKey: string, columns: string[], pageSize: number, sort: TableSort): Observable<Record<string, any>> {
        return this.adminSettingApi.saveAdminTableSettings(tableKey, {columns, pageSize, sort});
    }
}
